import React, { useState, useEffect } from "react";
import { CircularProgress } from '@material-ui/core';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { useSnackbar } from "notistack";

import { get_element_attachment_by_code } from '../Libraries/_redux/LibrariesCrud';
import { ElementTextView, ElementSurveyView, ElementReflectionView } from "../../components/Elements";
import { EnterPin } from "../../components/QuickAccess";
import * as temp from "../../../redux/ducks/temp.duck";
import { isEmpty } from "../../modules/Functions";

const QuickAccessPage = ({ tempData, quickAccessPin, actions, ...props }) => {
	const [attachment, setAttachment] = useState({});
	const [isSubmitting, setSubmitting] = useState(false);
	const [isValidPin, setIsValidPin] = useState(isEmpty(quickAccessPin) ? false : true);
	const [customizedText, setCustomizedText] = useState("");
	const { enqueueSnackbar } = useSnackbar();
	const snackbarAlert = (variant, message) => {
		// variant could be success, error, warning, info, or default
		enqueueSnackbar(message, { variant });
	};

	useEffect(() => {
		if(isValidPin) {
			setSubmitting(true);

			get_element_attachment_by_code(quickAccessPin).then((response) => {
				if(response.data.init[0].status == "error") {
					snackbarAlert('error', response.data.init[0].message);
				}
				else {
					setAttachment(response.data.data[0]);
				}

				setSubmitting(false);
			});
		}
	}, []);

	const Element = () => {
		switch(attachment?.attachment_type_id) {
			case 5: // text
				return (
					<ElementTextView
						attachment={attachment}
						tempData={tempData}
						setTemporaryData={actions.setTemporaryData}
						customizedText={customizedText}
					/>
				)
				break;
			case 6: // reflection
				return (
					<ElementReflectionView
						attachment={attachment}
						tempData={tempData}
						setTemporaryData={actions.setTemporaryData}
					/>
				)
				break;
			case 8: // survey
				return (
					<ElementSurveyView
						attachment={attachment}
						tempData={tempData}
						setTemporaryData={actions.setTemporaryData}
					/>
				)
				break;

			default:
				return (
					<></>
				)
		}
	}

	return (<>
		{
			isValidPin ? (
				<div className="quick-access-container">
					<EnterPin
						snackbarAlert={snackbarAlert}
						setAttachment={setAttachment}
						setIsValidPin={setIsValidPin}
						actions={actions}
						setSubmitting={setSubmitting}
						setCustomizedText={setCustomizedText}
						isRow={true}
					/>

					<div className="quick-access-content">
						{
							isSubmitting ? (
								<div className="quick-access-loading-container">
									<CircularProgress color="secondary" />
								</div>
							)
							: (
								<Element />
							)
						}
					</div>
				</div>
			)
			: (
				<center>
					<EnterPin
						snackbarAlert={snackbarAlert}
						setAttachment={setAttachment}
						setIsValidPin={setIsValidPin}
						actions={actions}
						setSubmitting={setSubmitting}
						setCustomizedText={setCustomizedText}
					/>
				</center>
			)
		}
	</>);
}

const mapStateToProps = (state, ownProps = {}) => {
	let data = {
		tempData: state?.tempData?.data,
		quickAccessPin: state?.tempData?.pin,
	}

	return data;
}

const mapDispatchToProps = dispatch => {
	return {
		actions: bindActionCreators(
			Object.assign(temp.actions),
			dispatch
		)
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(QuickAccessPage);